<div class="autocomplete-wrapper" [class.fluid]="fluid()">
  <label *ngIf="label()" [for]="id()" class="input-label">{{ label() }}</label>
  <p-autocomplete
    [inputId]="id()"
    [ngModel]="value()"
    (ngModelChange)="value.set($event)"
    [suggestions]="suggestions()"
    [optionLabel]="field()"
    [placeholder]="placeholder()"
    [disabled]="disabled()"
    [multiple]="multiple()"
    [dropdown]="dropdown()"
    [forceSelection]="forceSelection()"
    [minLength]="minLength()"
    [delay]="delay()"
    [appendTo]="appendTo()"
    [emptyMessage]="emptyMessage()"
    [styleClass]="styleClass()"
    [fluid]="fluid()"
    (completeMethod)="handleCompleteMethod($event)"
    (onSelect)="handleSelect($event)"
    (onUnselect)="handleUnselect($event)"
    (onClear)="handleClear()">

    <ng-template *ngIf="itemTemplate()" pTemplate="item" let-item>
      <ng-container *ngTemplateOutlet="itemTemplate()!; context: { $implicit: item }"></ng-container>
    </ng-template>

    <ng-template *ngIf="selectedItemTemplate()" pTemplate="selectedItem" let-item>
      <ng-container *ngTemplateOutlet="selectedItemTemplate()!; context: { $implicit: item }"></ng-container>
    </ng-template>

  </p-autocomplete>
</div>
